import React from "react";
import { useTranslation } from "react-i18next";
import { color } from "../../../../mui-theme/palette";
import Icon from "../../../../components/icon/icon";
import { SvgAssets } from "../../../../components/icon/assets";
import { textStyleSet } from "../../../../mui-theme/text.style";
import { IconFont } from "../../../../icon-font/iconfont";

interface IOSA2HSPromptProps {
  onClose: () => void;
}

export const IOSA2HSPrompt: React.FC<IOSA2HSPromptProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-11/12 max-w-md relative">
        {/* Close button */}
        <button
          className="absolute top-4 right-4 p-1 hover:bg-gray-100 rounded-full"
          onClick={onClose}
        >
          <Icon svg={SvgAssets.close} width={24} height={24} className="text-gray-600" />
        </button>

        {/* Reminder Icon */}
        <div className="flex justify-center mb-4">
          <Icon svg={SvgAssets.notice} width={80} height={80} className="text-blue-500" />
        </div>

        {/* Title */}
        <h2 className="text-center text-grey-33 font-sf-pro-text text-2xl font-medium leading-snug mb-4">
          {t("Common.install_candidate_portal")}
        </h2>

        {/* Content */}
        <div style={textStyleSet.text_14_med} className="text-grey33 leading-5">
          <div className="mb-3 flex flex-row">
            1. {t("Common.add_shortcut_popup_text1") /* PHKL Custom */}
            <div className="w-6 h-5 mx-1 rounded overflow-hidden">
              <Icon svg={SvgAssets.broswerShare} className="text-blue-500" />
            </div>
            {/* <div className="rounded w-6 h-5 bg-greyf4 flex justify-center items-center mx-1">
              <IconFont name="time-event" size={16} color={color.grey33} />
            </div> */}
            {/* {t("Common.button_in_the_toolbar")} PHKL Custom */}
          </div>
          <div className="mb-3 whitespace-normal break-words">
            2. {t("Common.add_shortcut_popup_text2") /* PHKL Custom */}
            <span className="rounded bg-gray-100 p-[6px] mx-1 mb-1 text-[8px] leading-none relative -top-[2px]">
              <span className="mr-2">{t("Common.add_to_home_screen")}</span>
              <IconFont name="add1" size={8} color={color.grey33} />
            </span>
            {/* {t("Common.scroll_down_menu_popup_to_find_item")} PHKL Custom */}
          </div>
          <div className="mb-3">{t("Common.add_shortcut_popup_text3") /* PHKL Custom */}</div>
        </div>
      </div>
    </div>
  );
};
